import { collectionEngineV1 } from '../apis.js';
const workflowStagesAPI = collectionEngineV1('/workflow-stages');
export const get = () => workflowStagesAPI('GET', '/');
export const create = (newWorkflowStage) => workflowStagesAPI('POST', '/', { body: newWorkflowStage });
export const patch = (workflowStageId, change) => workflowStagesAPI('PATCH', `/${workflowStageId}`, { body: change });
export const del = (workflowStageId) => workflowStagesAPI('DELETE', `/${workflowStageId}`);
//# sourceMappingURL=workflow-stages.js.map